import {atom} from "recoil";


export const ItemAtom = atom({
    key: "ItemAtom",
    default: [],
});